import "./importers/jquery";
import {} from "../../vendor/assets/javascripts/jquery-ujs";

import "../../vendor/assets/javascripts/jquery-ui/accordion";
import "../../vendor/assets/javascripts/jquery-ui/tabs";
import "../../vendor/assets/javascripts/jquery-ui/tooltip";

import "./commons/auto_fill";
import "./commons/custom_events";
import "./commons/date_range_picker";
import "./commons/dropdown";
import "./commons/form";
import "./commons/modernizr";
import "./commons/sb_grid";
import "./commons/search_filter";
import "./commons/search_filter_ajax";
import "./commons/uploader";
import "./commons/lorem_ipsum";
import "./commons/utils";
import "./commons/url_builder";
import "./commons/containers_toggler";
import "./commons/deviceQueries";
import "./commons/share_events";
import "./commons/input_mirror";
import "./importers/clipboard";

